import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import * as $ from 'jquery';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-cvm-header',
  templateUrl: './cvm-header.component.html',
  styleUrls: ['./cvm-header.component.scss']
})
export class CvmHeaderComponent implements OnInit {

  @Input() switch = false;

  top_of_page = true;
  display_menu = false;
  con_user = null;

  manager_con = null;

  constructor(private router:Router, private storagedata:StorageService) { 
    $("body").css("overflow", "auto");
    $(".congres-vituel-container").css("overflow", "auto");
    this.initScrollEvent();
    this.con_user = storagedata.getCongresConUser();
    this.manager_con = storagedata.getManagerCon();
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });
  }

  initScrollEvent(){
    $(window).scroll((event) => {
      ($(window).scrollTop() === 0) ? this.top_of_page = true : this.top_of_page = false;
    });
  }

  showMenu(){
    $("body").css("overflow", "hidden");
    $(".congres-vituel-container").css("overflow", "hidden");
    this.display_menu = true;
  }

  closeMenu(){
    $("body").css("overflow", "auto");
    $(".congres-vituel-container").css("overflow", "auto");
    this.display_menu = false;
  }
  
  preventAction($event){
    $event.preventDefault();
  }

  logOut($event){
    $event.preventDefault();
    this.storagedata.removeCongresConUser();
    location.reload();
  }

  logOutAsManager($event){
    this.preventAction($event);
    localStorage.removeItem('manager-code');
    location.reload();
  }

  vcRegister($event){
    this.preventAction($event);
    this.con_user ? alert('Vous êtes déjà connecté!') : this.router.navigateByUrl('/congres-virtuel/auth');
  }

  accessCongres($event){
    this.preventAction($event);
    this.con_user ? this.router.navigateByUrl('/congres-virtuel/welcome') : this.router.navigateByUrl('/congres-virtuel-main');
    this.closeMenu();
  }

  execAndClose($event){
    this.preventAction($event);
    this.closeMenu();
  }

}
